import React from "react";
import { Box, Chip, Grid, Paper, Typography, Divider } from "@mui/material";
export default function ZoneTab({ regions = [] }) {
  if (regions.length === 0) {
    return (
      <Paper
        elevation={0}
        sx={{
          p: 6,
          textAlign: "center",
          border: "1px dashed #D0D5DD",
          borderRadius: 3,
        }}
      >
        <Typography color="text.secondary">No Regions Found</Typography>
      </Paper>
    );
  }

  return (
    <Grid container spacing={3}>
      {regions.map((region) => (
        <Grid item xs={12} md={6} key={region.regionName}>
          <Paper
            elevation={0}
            sx={{
              minHeight: 250,
              p: 2,
              borderRadius: 3,

              border: `1px solid ${region.color}`,

              backgroundColor: `${region.color}`,

              transition: ".25s",

              "&:hover": {
                transform: "translateY(-3px)",
                boxShadow: "0 10px 25px rgba(0,0,0,.08)",
              },
            }}
          >
            {/* Region Name */}

            <Typography
              sx={{
                fontWeight: 600,
                fontSize: 16,
                color: "#2b2b2b",
              }}
            >
              {region.regionName || region?.name}
            </Typography>

            <Divider
              sx={{
                my: 1.5,
              }}
            />

            {/* States */}

            <Box display="flex" flexWrap="wrap" gap={1}>
              {(region.states || []).map((state) => (
                <Chip
                  key={state}
                  label={state}
                  size="small"
                  sx={{
                    backgroundColor: "transparent",
                    color: "#2b2b2b",
                    border: "1px solid #2b2b2b",

                    borderRadius: "6px",

                    fontSize: 12,
                    fontWeight: 400,

                    "& .MuiChip-label": {
                      px: 1.2,
                    },
                  }}
                />
              ))}
            </Box>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
}
